import { createSelector } from 'reselect';
import {
  getOneXpExperiments,
  hasOneXpRequestFinished
} from 'src/universal/redux/oneXp';

export const isAcxo1Variant = createSelector(
  [getOneXpExperiments, hasOneXpRequestFinished],
  (oneXpExperiments, oneXpDecided) => {
    return (
      oneXpExperiments['GCS-CXO-1-SBS-PS']?.dimensions[0]?.variant ===
        'experiment' && oneXpDecided
    );
  }
);
